import React from "react";
import { useParams } from "react-router";
import Retool from ".";
import EmptyState from "components/EmptyState";
import { buildingStore } from "store/Building/BuildingStore";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

const CertificationDashboard = ({ reportID }: { reportID: string }) => {
  const { id: BuildingId } = useParams();
  const { t } = useTranslation();

  const embeddedData = {
    building_id: BuildingId,
  };

  if (buildingStore.calculationsStatus.inProgress) {
    return (
      <EmptyState
        loading
        containerClassName="m-6 text-xs font-medium"
        loadingMessage={t("building.certDashboardLoadingMessage")}
      />
    );
  }

  if (!buildingStore.buildingMappingStatus.hasReport)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        containerClassName="m-6"
      />
    );

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-121px)]"
    />
  );
};

export default observer(CertificationDashboard);
